import React, {CSSProperties, ReactElement} from "react";
import {InfoIcon} from "@components/icons/Icons";
import {Button} from "antd";
import {useWindowSize} from "@components/window-size-provider";

interface ColorBlockAttribs {
    backgroundColor: string;
    color: string;
    leftChild: ReactElement | string;
    rightChild: ReactElement | string;
    rightTitle?: ReactElement | string;
    rightSubtext?: ReactElement | string;
    type?: "default" | "vertical" | "half" | "small" | undefined;
    style?: CSSProperties | undefined;
    className?: string;
    onClick?: () => void;
    onInfoClick?: () => void;
}

const ColorBlock = ({ backgroundColor, color, leftChild, rightTitle, rightChild, rightSubtext, type, className, onClick, onInfoClick }: ColorBlockAttribs) => {
    const windowDimensions = useWindowSize();
    const vertical = type === "vertical";
    const half = type === "half";
    const small = type === "small";

    const height = vertical ? "100%" : small ? (windowDimensions.isLargeScreen ? '62.5px' : '44px') : (windowDimensions.isLargeScreen ? '125px' : '88px');

    return (
        <div className={"position-container " + (vertical ? 'vertical ' : '')}>
            <div
                className={`color-block-container ` + (onClick ? 'cursor-pointer ' : '') + (vertical ? 'vertical ' : '') + (className ? className : '')}
                style={{
                    height: height,
                    backgroundColor: backgroundColor,
                }}
                onClick={onClick ? onClick : undefined}
            >
                {onInfoClick && (
                    <Button
                        onClick={onInfoClick}
                        className="info-icon"
                        type="link"
                        shape="circle"
                        style={{ color: color }}
                        icon={<InfoIcon />}
                    />

                )}
                <div className={"left-child "+ ((!windowDimensions.isLargeScreen && !small) ? 'small-screen ' : ' ') + (vertical ? 'vertical ' : '') + (half ? 'half ' : '') }>
                    {leftChild}
                </div>
                {(half) && (
                    <div
                        className="half-divider"
                        style={{ backgroundColor: color }}
                    />
                )}
                <div className={"right-child "+ ((!windowDimensions.isLargeScreen && !small) ? 'small-screen ' : ' ') + (vertical ? 'vertical ' : '') + (half ? 'half ' : '')}>
                    {rightTitle && rightTitle !== "" && (
                        <div
                            className={"right-title " + (vertical ? 'vertical ' : '')}
                            style={{ color: color }}
                        >
                            {rightTitle}
                        </div>
                    )}
                    {vertical && (
                        <div
                            className="vertical-divider"
                            style={{ backgroundColor: color }}
                        />
                    )}
                    <div
                        className={
                            'right-main ' +
                            (vertical ? 'vertical ' : '') +
                            (small ? 'small ' : '') +
                            (windowDimensions.isLargeScreen ? 'large-screen  ' : '')
                        }
                        style={{ color: color }}
                    >
                        {rightChild}
                    </div>
                    {rightSubtext && rightSubtext !== "" && (
                        <div
                            className={'right-subtext' + (vertical ? 'vertical ' : '')}
                            style={{ color: color }}
                        >
                            {rightSubtext}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ColorBlock;